import styles from './AdventureReviews.module.scss'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { defineMessage, useIntl } from 'react-intl'

export const ratingStars = {
  empty: `${window.staticPath}travel_dist/images/review-stars/star-empty.svg`,
  halfFilled: `${window.staticPath}travel_dist/images/review-stars/star-filled-half.svg`,
  filled: `${window.staticPath}travel_dist/images/review-stars/star-filled-full.svg`,
}

function getStars(rating) {
  const displayRating = rating > 4.5 ? 5 : rating
  return Array.from({ length: 5 }, (_, i) =>
    displayRating >= i + 1
      ? ratingStars.filled
      : displayRating > i
        ? ratingStars.halfFilled
        : ratingStars.empty,
  )
}

export default function AdventureReviewRating({ rating, className, isHeader }) {
  const { formatMessage } = useIntl()
  return (
    <div className={styles.ratingStarsContainer}>
      {isHeader && (
        <span className={styles.ratingNumber}>
          {rating.toFixed(1)}
        </span>
      )}
      <div className={cx(styles.ratingStars, className)}>
        {getStars(rating).map((star, index) => (
          <img
            key={index}
            src={star}
            alt={formatMessage(defineMessage({ defaultMessage: 'rating star' }))}
          />
        ))}
      </div>
    </div>
  )
}

AdventureReviewRating.propTypes = {
  rating: PropTypes.number.isRequired,
  className: PropTypes.string,
  isHeader: PropTypes.bool,
}
